module.exports = __webpack_public_path__ + "static/media/time-clock.586a34b3.svg";